import { useChannel } from "./ws/useChannel";
import type { Project } from "./useProjects";
import useQuery, { useRevalidate } from "./useQuery";
import useDebouncedCallback from "@ui/lib/hooks/useDebouncedCallback";

const useComputationsStatus = (project: Project) => {
  const projectId = project.id;
  const revalidate = useRevalidate();
  const callback = useDebouncedCallback(
    () => {
      void revalidate("/projects/:projectId(uuid)/computations/status", { projectId });
    },
    [revalidate, projectId],
    2_000,
    {
      leading: true,
      maxWait: 2_000,
      trailing: true,
    },
  );

  useChannel({ key: "computations_status", projectId }, callback, true);

  return useQuery("/projects/:projectId(uuid)/computations/status", {
    routeParams: { projectId },
  }).body;
};

export default useComputationsStatus;
